/**
 * まとめ発注の情報
 */
export interface BulkOrderInfo {
  amount: number;
  type: 'min' | 'max' | 'is';
}

/**
 * まとめ発注の情報の種類
 * min: 最小値、amount以上を表す
 * max: 最大値、amount以下を表す
 * is: amountと等しいを表す
 */
export type BulkOrderInfoType = 'min' | 'max' | 'is';

export const BulkOrderInfoType = {
  MIN: 'min' as BulkOrderInfoType,
  MAX: 'max' as BulkOrderInfoType,
  IS: 'is' as BulkOrderInfoType,
};
